import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Loading from 'zignal-landscape/lib/Loading';
import themeable from 'zignal-landscape/lib/themeable';
import TrashIcon from 'zignal-landscape/lib/Icon/TrashIcon';

import KeywordPill from './KeywordPill';

const KeywordTranslation = ({
  styles,
  isFetching,
  translations,
  enabledKeywordsCount,
  areTranslationsObsolete,
  handleAddLanguage,
  handleRemoveLanguage,
  handleToggleKeyword,
  handleUpdateTranslations
}) => {

  const addLanguageButtonStyles = {
    [styles.addLanguage]: true,
    [styles.overlayed]: areTranslationsObsolete
  };
  const addLanguageButton = (
    <div className={classnames(addLanguageButtonStyles)} onClick={handleAddLanguage}>
      <span>+ Language</span>
    </div>
  );

  const updateTranslationsButton = (
    <div className={styles.updateTranslations} onClick={handleUpdateTranslations} >
      Update Keyword Translation
    </div>
  );

  const loading = (style) => (
    <div className={style}>
      <Loading />
    </div>
  );

  const withNoTranslations = (
    <div className={styles.noTranslations}>
      { isFetching && loading(styles.noTranslationsLoading) }
      { addLanguageButton }
    </div>
  );

  const translationStyles = {
    [styles.translationBlock]: true,
    [styles.overlayed]: areTranslationsObsolete
  };
  const withTranslations = (
    <div>
      <div className={classnames(translationStyles)}>
        <span className={styles.title}>{`The following ${enabledKeywordsCount} keywords will be searched`}</span>
        { isFetching && loading(styles.withTranslationsLoading) }
        { translations.map(translation => {
          const isOriginal = translation.language.code === 'ZIGNAL';
          const languageClass = isOriginal ? styles.originalLanguage : styles.translation;
          return (
            <div key={translation.language.code} className={languageClass}>
              <div className={styles.language}>
                {translation.language.label}
              </div>
              <div className={styles.keywords}>
                {translation.keywords.map(keyword => (
                  <KeywordPill
                    key={`${translation.language.code}-${keyword.keywordId}`}
                    id={keyword.keywordId}
                    text={keyword.text}
                    enabled={keyword.enabled}
                    onClick={() => handleToggleKeyword(translation.language.code, keyword.keywordId)}
                  />
                ))}
              </div>
              {!isOriginal && (
                <TrashIcon
                  className={styles.removeLanguage}
                  onClick={() => handleRemoveLanguage(translation.language.code)}
                />
              )}
            </div>
          );
        })}
      </div>
      { addLanguageButton}
    </div>
  );

  return (
    <div className={styles.translationsContainer}>
      { areTranslationsObsolete && updateTranslationsButton}
      { areTranslationsObsolete && <div className={styles.obsoleteTranslations} />}
      { translations.length === 0 ? withNoTranslations : withTranslations }
    </div>
  );
};

KeywordTranslation.propTypes = {
  styles: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  translations: PropTypes.array.isRequired,
  enabledKeywordsCount: PropTypes.number.isRequired,
  areTranslationsObsolete: PropTypes.bool.isRequired,
  handleAddLanguage: PropTypes.func.isRequired,
  handleRemoveLanguage: PropTypes.func.isRequired,
  handleToggleKeyword: PropTypes.func.isRequired,
  handleUpdateTranslations: PropTypes.func.isRequired,
};

export default themeable(KeywordTranslation);
